import { render, staticRenderFns } from "./Businessnews.vue?vue&type=template&id=262fadb6&scoped=true"
import script from "./Businessnews.vue?vue&type=script&lang=js"
export * from "./Businessnews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262fadb6",
  null
  
)

export default component.exports